import { createStyles } from 'antd-style'

import type { TableVariant } from './types'

type Props = {
  onRow?: boolean
  variant?: TableVariant
}

export const useStyles = createStyles(
  ({ token }, { onRow = false, variant = 'outlined' }: Props) => {
    const isOutlined = variant === 'outlined'
    const toolbarGap = token.paddingSM * 1.2

    return {
      pagination: {
        backgroundColor: token.colorBgContainer,
        margin: '0 !important',
        paddingBlock: token.paddingSM,
        paddingInline: isOutlined ? token.paddingSM : 0,
        borderRadius: `0 0 ${token.borderRadius}px ${token.borderRadius}px`
      },
      toolbar: {
        '.ant-pro-table-list-toolbar': {
          padding: toolbarGap
        },
        ':not(:empty)': {
          padding: isOutlined ? toolbarGap : `0 0 ${toolbarGap}px`
        },
        '.ant-pro-table-list-toolbar-right': {
          gap: token.marginXXS
        },
        '.ant-pro-table-list-toolbar-container': {
          padding: 0,
          alignItems: 'start'
        },
        '.ant-pro-table-list-toolbar-container-mobile': {
          flexDirection: 'row',
          '@media (max-width: 375px)': {
            flexDirection: 'column'
          }
        },
        '.ant-pro-table-list-toolbar-title': {
          fontWeight: 400
        },
        '.ant-pro-table-list-toolbar-setting-item': {
          display: 'flex',
          alignItems: 'center',
          paddingInline: token.paddingXS * 0.75,
          marginInline: 0,
          lineHeight: `${token.controlHeight}px`
        },
        '.ant-pro-table-list-toolbar-setting-items': {
          gap: 4
        }
      },
      table: {
        ...(isOutlined && {
          borderRadius: token.borderRadius,
          border: `${token.lineWidth}px ${token.lineType} ${token.colorBorderSecondary}`,
          overflow: 'clip'
        }),

        '.action-column-title': {
          display: 'none'
        },

        '.ant-table': {
          borderRadius: `${token.borderRadius}px ${token.borderRadius}px 0 0 !important`,
          marginBottom: `-${token.lineWidth}px`
        },
        '.ant-table-bordered': {
          margin: `-${token.lineWidth}px`
        },

        '.ant-table-row': {
          cursor: onRow ? 'pointer' : 'auto',

          '.ant-table-cell-fix-right': {
            cursor: 'auto'
          }
        }
      }
    }
  }
)
